/* eslint-disable prettier/prettier */
import $ from 'jquery';
import { gsap } from 'gsap';
// import { CustomEase } from "gsap/CustomEase";
import { ManagePage } from '../Manage/_ManagePage.js';

import Unit from '../Global/_Unit.js';

// gsap.registerPlugin(CustomEase);


export default class HebiAnim {

  constructor() {
    // this.easeStr = 'elastic.out(1,0.5)';
    // this.easeStr = 'power4.out'
    this.easeStr = 'expo.inOut';

    // CustomEase.create('custom', 'M0,0 C0.437,0 0.577,0.206 0.706,0.327 0.75,0.368 1,0.717 1,1 ')
    // this.easeStr = 'custom';




    this.durationNum = 1.4;
    // this.duration2Num = 1.5;
    this.hebi = '.hebi__bg';
    this.hebiSp = '.hebi__bg--sp';
    // this.param = { duration: this.durationNum, ease: this.easeStr, delay: 0.4 };
    this.param = { duration: this.durationNum, ease: this.easeStr };
    // this.param2 = { duration: this.durationNum, ease: this.easeStr };

    this.hideSpHebi();
  }

  hideSpHebi() {
    $(this.hebiSp).hide();
  }

  setAni(num) {
    // 蛇クルクル 4はなし
    // if(
    //   num == 2 ||
    //   num == 3 ||
    //   num == 5
    // ) this.hebiRotation();

    if (num == 1) {

      if(Unit.isPc()) gsap.to(this.hebi, {scale: 1.8, rotation: -46, x: '-82%' , y: '130%' , ...this.param });
      else            gsap.to(this.hebi, {scale: 1.1, rotation: -46, x: '-67%' , y: '100%' , ...this.param });

    } else if (num == 2) {

      if(Unit.isPc()) gsap.to(this.hebi, {scale: 1.5, rotation: 13, x: '-34%' , y: '-44%' , ...this.param });
      else            gsap.to(this.hebi, {scale: 1.1, rotation: 9, x: '-46%' , y: '-29%' , ...this.param });

    } else if (num == 3) {

      if(Unit.isPc()) gsap.to(this.hebi, {scale: 1.7, rotation: 90, x: '143%' , y: '-124%' , ...this.param });
      else            gsap.to(this.hebi, {scale: 1.1, rotation: 88, x: '74%' , y: '-73%' , ...this.param });

    } else if (num == 4) {

      if(Unit.isPc()) gsap.to(this.hebi, {scale: 1.7, rotation: -71, x: '-74%' , y: '191%' , ...this.param });
      else            gsap.to(this.hebi, {scale: 1.1, rotation: -72, x: '-71.5%' , y: '140%' , ...this.param });

    } else if (num == 5) {

      if(Unit.isPc()) gsap.to(this.hebi, {scale: 1.7, rotation: 20, x: '26%' , y: '-98%' , ...this.param });
      else            gsap.to(this.hebi, {scale: 1.15, rotation: 23, x: '2.5%' , y: '-68%' , ...this.param });

    } else if (num == 6) {

      if(Unit.isPc()) {
        const hebiImgH = $('.hebi__bg').height();
        //　蛇よりも大きいウィンドウサイズのとき
        if ($(window).height() > hebiImgH) {
          gsap.to(this.hebi, {scale: 1, rotation: 0, x: '-7%' , y: '-23%' , onComplete: this.fadeInSun , ...this.param });
        } else {
          gsap.to(this.hebi, {scale: 1, rotation: 0, x: '-7%' , y: '-23%' , onComplete: this.fadeInSun , ...this.param });
        }
        // gsap.to(this.hebi, {scale: 1, rotation: 0, x: '-7%' , y: '-23%' , onComplete: this.fadeInSun , ...this.param2 });
        $(this.hebiSp).hide();

      } else {
          gsap.to(this.hebi, {scale: 1.1, rotation: 20, x: '-100%' , y: 200 , duration: 0.7, ease: 'power4.out' });
          $(this.hebiSp).show();
          gsap.fromTo(this.hebiSp, { y: '100%' } ,{ y: '-15%', delay: 0.7 , ...this.param });
      }
    }

    if (num < 6) {
      this.fadeOutSun();
    }

  }

  // hebiRotation() {
  //   gsap.set('.hebi', { rotation: 0 });
  //   gsap.to('.hebi', { rotation: 360, duration: 1, ease: 'power4.out' });
  // }

  fadeInSun() {
    $('.hebi__bgSun').addClass('fadeIn');
  }

  fadeOutSun() {
    $('.hebi__bgSun').removeClass('fadeIn');
  }
}
